import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

// Mount SPA như bình thường vào #root
const rootElement = document.getElementById("root")
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

// Parse JSON từ attribute
const parseJsonAttr = (el, attrName, fallback = {}) => {
  const raw = el.getAttribute(attrName)
  if (!raw) return fallback
  try {
    return JSON.parse(raw)
  } catch (err) {
    console.warn(`Invalid JSON in attribute "${attrName}":`, err)
    return fallback
  }
}

// Web Component
class Map4DSolarMapElement extends HTMLElement {
  static get observedAttributes() {
    return ["config"]
  }

  constructor() {
    super()
    this._mountPoint = document.createElement("div")
    this._mountPoint.style.width = "100%"
    this._mountPoint.style.height = "100%"
    this._root = null
    this._mounted = false
  }

  connectedCallback() {
    if (this._mounted) return

    this.innerHTML = "" // Xoá nội dung cũ nếu có
    this.appendChild(this._mountPoint)

    this._root = ReactDOM.createRoot(this._mountPoint)
    this._renderReact()

    this._mounted = true
  }

  disconnectedCallback() {
    // Cleanup React root khi component bị remove khỏi DOM
    if (this._root) {
      this._root.unmount()
      this._root = null
    }
    this._mounted = false
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (this._root && oldValue !== newValue) {
      this._renderReact()
    }
  }

  set options(value) {
    this._options = value
    if (this._mounted) this._renderReact()
  }
  get options() {
    return this._options
  }

  _renderReact() {
    if (!this._root) return

    const config = parseJsonAttr(this, "config")
    const options = this.options || []

    this._root.render(
      <App
        config={config}
        options={options}
        dispatchToVue={(eventName, detail) => {
          this.dispatchEvent(
            new CustomEvent(eventName, {
              detail,
              bubbles: true,
              composed: true,
            }),
          )
        }}
      />,
    )
  }
}

if (!customElements.get("map4d-solar-map")) {
  customElements.define("map4d-solar-map", Map4DSolarMapElement)
}

reportWebVitals()
